export function returnToSuperAdmin(url) {
  window.location.assign(url);
}
